module.exports = __webpack_public_path__ + "static/media/door0202.33918cb7.jpg";